module.exports = function (tooltipFunction) {

	return {
		// The text color. Specify an HTML color value.
		// Type: string
		// Default: #ffffff
		"fontColor": "#333",
		
		// The font family to use for all text.
		// Type: string
		// Default: auto
		"fontFamily": "Roboto Slab",
		
	  
		// The font size for all text, in points.
		//Type: number
		//Default: 12
		"fontSize": 14,
	  
		// Draws the chart inside an inline frame. (Note that on IE8, this option is ignored; all IE8 charts are drawn in i-frames.)
		// Type: boolean
		// Default: false
		"forceIFrame": false,
	   
		//The color of the header section for each node. Specify an HTML color value.
		//Type: string
		//Default: #988f86
		"headerColor": "#f5f5f5",
	  
		// The height of the header section for each node, in pixels (can be zero).
		// Type number
		// Default: 0
		"headerHeight": 80,
	  
		// The color of the header of a node being hovered over. Specify an HTML 
		// color value or null; if null this value will be headerColor lightened by 35%.
		// Type: string
		// Default: null
		"headerHighlightColor": null,
	  
		// Determines if elements should show highlighted effects when moused over. If set to true, 
		// highlighting for different elements can be specified using the various highlightColor options.
		// Type: boolean
		// Default: false
	  
		"highlightOnMouseOver": false,
	  
		// When maxPostDepth is greater than 1, causing nodes below the current depth to be shown, hintOpacity specifies how transparent it should be. It should be 
		// between 0 and 1; the higher the value, the fainter the node.
		// Type: number
		// Default: 0.0
		"hintOpacity": 0.0,
	  
		// The color for a rectangle with a column 3 value of maxColorValue. Specify an HTML color value.
		// Type: string
		// Default: #00dd00
		"maxColor": "#e1af27",
	  
		// The maximum number of node levels to show in the current view. Levels will be flattened into 
		//the current plane. If your tree has more levels than this, you will have to go up or down to see them. You can additionally see maxPostDepth levels below this as shaded rectangles within these nodes.
		// Type: number
		// Default: 1
		"maxDepth": 1,
	  
		// The highlight color to use for the node with the largest value in column 3. Specify an HTML color value or null; 
		// If null, this value will be the value of maxColor lightened by 35%
		// Type: string
		// Default: null
		"maxHighlightColor": null,
	  
		// How many levels of nodes beyond maxDepth to show in "hinted" fashion. Hinted nodes are 
		// shown as shaded rectangles within a node that is within the maxDepth limit.
		// Type: number
		// Default: 0
		"maxPostDepth": 0,
	  
	  
		// The maximum value allowed in column 3. All values greater than this will be trimmed 
		// to this value. If set to null, it will be set to the max value in the column.
		// Type: number
		// Default: null
		"maxColorValue": null,
	  
		// The color for a rectangle with a column 3 value midway between maxColorValue and minColorValue. 
		// Specify an HTML color value.
		// Type: string
		// Default: #000000
		"midColor": "#e1af27",
	  
		// The highlight color to use for the node with a column 3 value near the median of 
		// minColorValue and maxColorValue. Specify an HTML color value or null; if null, this value will be the value of midColor lightened by 35%.
		// Type: string
		// Default: null
		"midHighlightColor": null,
	  
		// The color for a rectangle with the column 3 value of minColorValue. Specify an HTML color value.
		// Type: string
		// Default: #dd0000
		"minColor": "#e1af27",
	  
		// The highlight color to use for the node with a column 3 value 
		// nearest to minColorValue. Specify an HTML color value or null; if null, this value will be the value of minColor lightened by 35%
		// Type: string
		// Default: null
		"minHighlightColor": null,
	  
	  
		// The minimum value allowed in column 3. All values less than this 
		// will be trimmed to this value. If set to null, it will be calculated as the minimum value in the column.
		// Type: number
		// Default: null
		"minColorValue": null,
	  
		// The color to use for a rectangle when a node has no value for column 3, 
		// and that node is a leaf (or contains only leaves). Specify an HTML color value.
		// Type: string
		// Default: #000000
		"noColor": "#000000",
	  
		// The color to use for a rectangle of "no" color when highlighted. 
		// Specify an HTML color value or null; if null, this will be the value of noColor lightened by 35%.
		// Type: string
		// Default: null
		"noHighlightColor": null,
	  
		// Whether or not to show a color gradient scale from minColor to 
		// maxColor along the top of the chart. Specify true to show the scale.
		// Type: boolean
		// Default: false
		"showScale": false,
	  
		// Whether to show tooltips.
		// Type: boolean
		// Default: true
		"showTooltips": true,
	  
	  
		// An object that specifies the text style, for certain charts that 
		// have text in the content area such as the treemap. The object has this format:
		//   { color: <string>,
		//   fontName: <string>,
		//   fontSize: <number>,
		//   bold: <boolean>,
		//   italic: <boolean> }
		// The color can be any HTML color string, for example: 'red' or '#00cc00'. Also see fontName and fontSize.
		// Type: object
		// Default: {color: 'black', fontName: <global-font-name>, fontSize: <global-font-size>}
		"textStyle": { 
		  "color": "#000",
		  "fontName": "Roboto Slab",
		  "fontSize": 14,
		  "bold": false,
		  "italic": false 
		},
	  
		// Text to display above the chart.
		// Type: string
		// Default: no title
		"title": "",
	  
		//An object that specifies the title text style. The object has this format:
		// { color: <string>,
		//   fontName: <string>,
		//   fontSize: <number>,
		//   bold: <boolean>,
		//   italic: <boolean> }
		// The color can be any HTML color string, for example: 'red' or '#00cc00'. Also see fontName and fontSize.
		// Type: object
		//Default: {color: 'black', fontName: <global-font-name>, fontSize: <global-font-size>}
		"titleTextStyle": {
		  "color": "#333", 
		  "fontName": "Roboto Slab", 
		  "fontSize": 12
		},
	  
	  
		//Whether to use weighted averages for aggregation.
		// Type: boolean
		// Default: false
		"useWeightedAverageForAggregation": false,
	
		"generateTooltip": tooltipFunction
		
	  
	  };

};
	  
  
  
  
  
  
	  
  
  
  